"use strict";

var dataHooks = {
  closeButton: 'BaseModal-closeButton',
  helpButton: 'BaseModal-helpButton',
  secondaryButton: 'BaseModal-secondaryButton',
  primaryButton: 'BaseModal-primaryButton',
  sideActions: 'BaseModal-sideActions',
  footnote: 'BaseModal-footnote'
};
module.exports = {
  dataHooks: dataHooks
};